import { render, staticRenderFns } from "./Accordions.vue?vue&type=template&id=5a2ca2b9&scoped=true&"
import script from "./Accordions.vue?vue&type=script&lang=ts&"
export * from "./Accordions.vue?vue&type=script&lang=ts&"
import style0 from "./Accordions.vue?vue&type=style&index=0&id=5a2ca2b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ca2b9",
  null
  
)

export default component.exports